<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2"
                        @keyup="slugBuild" label="Title" required="true" placeholder="i.e How to Create an Account" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Slug" required="true" placeholder="i.e how-to-create-an-account" />

                    <select-input v-model="form.cat_id" :error="form.errors.cat_id" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Category" required="true">
                        <option :value=null>Select Category</option>
                        <option v-for="userManualC in userManualCat" :key="userManualC.id" :value='userManualC.id'>
                            {{ userManualC.title }}
                        </option>
                    </select-input>

                    <text-input v-model="form.order" :error="form.errors.order" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Order" type="number" placeholder="0" />

                    <textarea-input v-model="form.description" :error="form.errors.description"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Short Description"
                        placeholder="Brief description of this manual..." />

                    <div class="pb-8 pr-6 w-full lg:w-1/1">
                        <label class="form-label">Content:</label>
                        <QuillEditor v-model:content="form.content" theme="snow" contentType="html" :toolbar="[
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ['link', 'image'],
                            ['clean']
                        ]" style="min-height: 300px;" />
                        <div v-if="form.errors.content" class="form-error">{{ form.errors.content }}</div>
                    </div>

                    <file-input v-model="form.attachment" :error="form.errors.attachment"
                        class="pb-8 pr-6 w-full lg:w-1/1" type="file" accept=".pdf,.doc,.docx"
                        label="Attachment (PDF/DOC)" />

                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
                </div>
                <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
            </form>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/Shared/Breadcrumbs'
    import Button from '@/Shared/Button'
    import FileInput from '@/Shared/FileInput'
    import Layout from '@/Shared/Layout'
    import LoadingButton from '@/Shared/LoadingButton'
    import SelectInput from '@/Shared/SelectInput'
    import StatusToogleButton from '@/Shared/StatusToogleButton'
    import TextareaInput from '@/Shared/TextareaInput'
    import TextInput from '@/Shared/TextInput'
    import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
    import { ref, toRefs, inject } from 'vue'
    import { QuillEditor } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    export default {
        components: {
            Head,
            Link,
            LoadingButton,
            SelectInput,
            TextInput,
            Breadcrumbs,
            StatusToogleButton,
            Button,
            TextareaInput,
            FileInput,
            QuillEditor
        },
        layout: Layout,
        remember: 'form',
        props: {
            userManualCat: Array
        },
        setup(props) {
            const { userManualCat } = toRefs(props)
            const form = useForm({
                title: null,
                cat_id: null,
                slug: null,
                description: null,
                content: null,
                order: 0,
                status: true,
                attachment: null
            })
            const type = ref('create')
            const title = ref('User Manual')
            const url = ref('/backend/user-manuals')
            const createUrl = ref('')
            const swal = inject('$swal')
            const store = () => {
                swal({
                    title: 'Are you sure?',
                    text: "You want to proceed with this action",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                }).then((result) => {
                    if (result.isConfirmed) {
                        form.post(`${url.value}`, { forceFormData: true })
                        swal.fire(
                            'Added!',
                            'Your infomation has been Added.',
                            'success'
                        )
                    }
                });
            }
            const slugBuild = () => {
                form.slug = form.title.replace(/\s/g, '-').toLowerCase()
            }
            return {
                form,
                type,
                title,
                url,
                createUrl,
                store,
                slugBuild,
                userManualCat
            }
        }
    }
</script>
